const HisClock = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="24"
      height="24"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1797 22.1042C17.7025 22.1042 22.1797 17.6271 22.1797 12.1042C22.1797 6.5814 17.7025 2.10425 12.1797 2.10425C6.65684 2.10425 2.17969 6.5814 2.17969 12.1042C2.17969 17.6271 6.65684 22.1042 12.1797 22.1042Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1797 6.10425V12.1042L16.1797 14.1042"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisClock;
